// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error_OuVcU {
  color : var( --pink );
  visibility:visible;
  float:left;
}

.placeholder_M3skj {
  height: 36px;
}

.noError_VJhXD {
  visibility:hidden;
  float:left;
}`, "",{"version":3,"sources":["webpack://./src/views/JsonEditorDialog.css"],"names":[],"mappings":"AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ","sourcesContent":["@import \"../style/theme.css\";\n\n.error {\n  color : var( --pink );\n  visibility:visible;\n  float:left;\n}\n\n.placeholder {\n  height: 36px;\n}\n\n.noError {\n  visibility:hidden;\n  float:left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error": `error_OuVcU`,
	"placeholder": `placeholder_M3skj`,
	"noError": `noError_VJhXD`
};
export default ___CSS_LOADER_EXPORT___;
